export default __webpack_public_path__ + "afc34fbcebcc18d2b7b3a44b83b903c4.png";